import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    routes: [
        // 초기 진입 페이지
        { path: '/', redirect: '/login' },

        // 본인인증 페이지
        { path: '/nice', name: 'nice', component: () => import('@/views/Nice.vue') },
        { path: '/niceComplete', name: 'niceComplete', component: () => import('@/views/NiceComplete.vue') },

        // 00, 01 : member 폴더
        { path: '/agree', name: 'agree', component: () => import('@/views/member/Agree.vue') },
        { path: '/findEmail', name: 'findEmail', component: () => import('@/views/member/FindEmail.vue') },
        { path: '/findEmailResult', name: 'findEmailResult', component: () => import('@/views/member/FindEmailResult.vue') },
        { path: '/join', name: 'join', component: () => import('@/views/member/Join.vue') },
        { path: '/login', name: 'login', component: () => import('@/views/member/Login.vue') },
        { path: '/passwordResetComplete', name: 'passwordResetComplete', component: () => import('@/views/member/PasswordResetComplete.vue') },

        // 02 : terms 폴더
        { path: '/privacyConsent', name: 'privacyConsent', component: () => import('@/views/terms/PrivacyConsent.vue') },
        { path: '/locationServiceTerms', name: 'locationServiceTerms', component: () => import('@/views/terms/LocationServiceTerms.vue') },
        { path: '/userDataSharingConsent', name: 'userDataSharingConsent', component: () => import('@/views/terms/UserDataSharingConsent.vue') },
        
        // 03 : home 폴더
        { path: '/home', name: 'home', component: () => import('@/views/home/Home.vue'), meta: { auth: true }, },

        // 04 : entryAndExit 폴더
        { path: '/service', name: 'service', component: () => import('@/views/entryAndExit/Service.vue'), meta: { auth: true }, },
        { path: '/alarmApplication', name: 'alarmApplication', component: () => import('@/views/entryAndExit/AlarmApplication.vue'), meta: { auth: true }, },
        { path: '/deviceRegPage', name: 'deviceRegPage', component: () => import('@/views/entryAndExit/DeviceRegPage.vue'), meta: { auth: true }, },
        { path: '/deviceRegComplete', name: 'deviceRegComplete', component: () => import('@/views/entryAndExit/DeviceRegComplete.vue'), meta: { auth: true }, },

        // 05 : setting 폴더
        { path: '/setting', name: 'setting', component: () => import('@/views/setting/Setting.vue'), meta: { auth: true }, },
        { path: '/myInfo', name: 'myInfo', component: () => import('@/views/setting/MyInfo.vue'), meta: { auth: true }, },
        { path: '/myInfoModify', name: 'myInfoModify', component: () => import('@/views/setting/MyInfoModify.vue'), meta: { auth: true }, },
        { path: '/pwSet', name: 'pwSet', component: () => import('@/views/setting/PwSet.vue'), meta: { auth: true }, },
        { path: '/alarm', name: 'alarm', component: () => import('@/views/setting/Alarm.vue'), meta: { auth: true }, },
        { path: '/alarmSet', name: 'alarmSet', component: () => import('@/views/setting/AlarmSet.vue'), meta: { auth: true }, },
        { path: '/noticeList', name: 'noticeList', component: () => import('@/views/setting/NoticeList.vue'), meta: { auth: true }, },
        { path: '/noticeView', name: 'noticeView', component: () => import('@/views/setting/NoticeView.vue'), meta: { auth: true }, },
        { path: '/complaint', name: 'complaint', component: () => import('@/views/setting/Complaint.vue'), meta: { auth: true }, },
        { path: '/complaintList', name: 'complaintList', component: () => import('@/views/setting/ComplaintList.vue'), meta: { auth: true }, },
        { path: '/withdraw', name: 'withdraw', component: () => import('@/views/setting/Withdraw.vue'), meta: { auth: true }, },
        // { path: '/withdraw', name: 'withdraw', component: () => import('@/views/setting/Withdraw.vue'), },

        // 06 : family 폴더
        { path: '/familyList', name: 'familyList', component: () => import('@/views/family/FamilyList.vue'), meta: { auth: true }, },
        { path: '/familyDetail', name: 'familyDetail', component: () => import('@/views/family/FamilyDetail.vue'), meta: { auth: true }, },
        { path: '/guardianEdit', name: 'guardianEdit', component: () => import('@/views/family/GuardianEdit.vue'), meta: { auth: true }, },
        { path: '/guardianAdd', name: 'guardianAdd', component: () => import('@/views/family/GuardianAdd.vue'), meta: { auth: true }, },
        { path: '/familyEdit', name: 'familyEdit', component: () => import('@/views/family/FamilyEdit.vue'), meta: { auth: true }, },
        { path: '/addGrdAcceptComplete', name: 'addGrdAcceptComplete', component: () => import('@/views/family/AddGrdAcceptComplete.vue') },
        { path: '/addGrdDenyComplete', name: 'addGrdDenyComplete', component: () => import('@/views/family/AddGrdDenyComplete.vue') },
        { path: '/addGrdApply/:encId', name: 'addGrdApply', component: () => import('@/views/family/AddGrdApply.vue') },
        
        // 07 : safezone 폴더
        { path: '/sfzUserList', name: 'sfzUserList', component: () => import('@/views/safezone/SfzUserList.vue'), meta: { auth: true }, },
        
        // 없는 페이지
        { path: '*', component: () => import('@/components/common/NotFoundPage.vue') },

        // 사용 안하는 페이지
        // { path: '/mapAlarm', name: 'mapAlarm', component: () => import('@/components/map/MapAlarm.vue'), meta: { auth: true }, },
        // { path: '/map', name: 'map', component: () => import('@/components/map/Map.vue'), meta: { auth: true }, },
        // { path: '/family', name: 'family', component: () => import('@/components/family/Family.vue'), meta: { auth: true }, },
        // { path: '/generateSfzKey', name: 'generateSfzKey', component: () => import('@/views/setting/GenerateSfzKey.vue'), meta: { auth: true }, },
        // { path: '/terms', name: 'terms', component: () => import('@/views/terms/Terms.vue') },
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.auth && !store.getters.isLogin) {
      console.log('인증이 필요합니다');
      next('/login');
      return;
    }
    next();
  });
  
  export default router;